function QuoteOptions(quoteConfiguration, serviceResponseRepository, quoteResultModelBuilder, storage) {

	var coverTypeClasses = quoteConfiguration.coverTypeClasses;

	var allCoverTypes = quoteConfiguration.allCoverTypes;

	var allCoverTypesByKey = quoteConfiguration.allCoverTypesByKey;

	var allPaymentFrequencies = quoteConfiguration.allPaymentFrequencies;

	var _reversePaymentFrequenciesLookup = quoteConfiguration._reversePaymentFrequenciesLookup;

	var allQuoteTypes = quoteConfiguration.allQuoteTypes;

	var quoteRuleOptions = quoteConfiguration.quoteRuleOptions;

	var testQuoteDeclineOptions = quoteConfiguration.testQuoteDeclineOptions;

	var defaultCoverType = quoteConfiguration.defaultCoverType;
	var defaultPaymentFrequency = quoteConfiguration.defaultPaymentFrequency ;
	var availableQuoteResults =[];
	var defaultRequotePageName = quoteConfiguration.defaultRequotePageName;

	var defaultOffering = quoteConfiguration.defaultOffering || null ;

	function setSelectedCoverType(coverTypeClass, coverTypeSubClass) {
		if ( ! coverTypeClass )
			throw 'Invalid cover type class provided' ;

		if ( ! coverTypeSubClass )
			coverTypeSubClass = 'standard' ;
		if (!coverTypeClasses[coverTypeClass] || !coverTypeClasses[coverTypeClass].subClasses[coverTypeSubClass]) {
		    selectedCoverType = allCoverTypesByKey[coverTypeClass];
		}
		else {
		    selectedCoverType = coverTypeClasses[coverTypeClass].subClasses[coverTypeSubClass];
		}
		if ( ! selectedCoverType) {
			console.log('Empty cover type selected.');
		}

		storage.setItem('selectedCoverType' , selectedCoverType ) ;
	}

	function setSelectedOffering(offering) {
		if ( ! offering )
			throw 'Invalid offering provided' ;

		//get offering object from the configuration
		selectedOffering = quoteConfiguration.allOfferings[offering];

		if ( ! selectedOffering) {
			console.log('Empty cover type selected.');
		}

		storage.setItem('selectedOffering' , selectedOffering ) ;
	}

	function getSelectedOffering(){
		var so = storage.getItem('selectedOffering');
		if ( ! so.descriptor )
			so = defaultOffering;
		return so;
	}

	function setDefaultCoverType() {
		setSelectedCoverType(defaultCoverType.superType, defaultCoverType.subType);
	}


	function setSelectedPaymentFrequency(paymentFrequency) {
		selectedPaymentFrequency = _reversePaymentFrequenciesLookup[paymentFrequency];
		storage.setItem('selectedPaymentFrequency' , selectedPaymentFrequency ) ;
		if ( ! selectedPaymentFrequency )
			throw 'Invalid payment frequencey selected' ;
	}

	function getSelectedCoverType(){
		var ct = storage.getItem('selectedCoverType');
		if ( ! ct.descriptor )
			ct = defaultCoverType;
		return ct;
	}

	function getSelectedPaymentFrequency() {
		var selectedPaymentFrequency = storage.getItem('selectedPaymentFrequency');
		if ( typeof(selectedPaymentFrequency) != 'string' )
			selectedPaymentFrequency = defaultPaymentFrequency ;

		return selectedPaymentFrequency;
	}

	function getSelectedPaymentFrequencyForService() {
		var selectedPaymentFrequency = getSelectedPaymentFrequency();
		return allPaymentFrequencies[selectedPaymentFrequency] ;
	}

	function getSelectedQuoteResult() {
		var selectedQuoteResult = null ;
		var mergedQuoteResults = getMergedQuoteResults(availableQuoteResults);
		var coverTypeSelector = getCoverTypeSelector() ; 
		if ( mergedQuoteResults && coverTypeSelector )
			return mergedQuoteResults[coverTypeSelector];

		return null ;
	}

	function getCoverTypeSelector() {
		if (getSelectedCoverType()) {
			var coverTypeSelector = getSelectedCoverType().descriptor ;
			var selectedOffering = getSelectedOffering();
			if ( selectedOffering )
				coverTypeSelector += '_' + selectedOffering.descriptor ;

			return coverTypeSelector;	
		}
	}


	/**
	* @return the selected quote result for the selected payment frequency.
	*/
	function getSelectedQuoteResultForPayment() {
		var qr = getSelectedQuoteResult() ;
		if ( qr ) {
			return qr.getQuoteResult( getSelectedPaymentFrequency() );
		}

		return null;
	}

	function setAvailableQuoteResults(quoteResults) {
		availableQuoteResults = quoteResults ;
	}

	function clearQuoteResults() {
		quoteResultModelBuilder.clear() ; 
	}

	function getMergedQuoteResults(quoteResults) {
		if ( ! quoteResults ) return null;

		quoteResults.forEach(function(result) {
			quoteResultModelBuilder.addQuoteResult(result) ;
		});

		return quoteResultModelBuilder.getMergedQuoteResults();
	}

	function getAvailableCoverTypes() {
		var availableQuoteResults = serviceResponseRepository.getLastResponseFrom('quote') ;
		var availableCoverTypes = [];
		if ( availableQuoteResults ) {
			availableQuoteResults.vehicles[0].availableCoverTypes.forEach(function(qr) {	
				availableCoverTypes.push(allCoverTypesByKey[qr] );
			})
		}
		return availableCoverTypes;
	}

	function getAvailableSumInsuredTypes(){
		var availableQuoteResults = serviceResponseRepository.getLastResponseFrom('quote') ;
		var availableSumInsuredTypes = [];
		if (availableQuoteResults) {
		    if (availableQuoteResults.productCode == "QPYPersonalMotorcycle") {
		        availableQuoteResults.motorcycles[0].availableSumInsuredTypes.forEach(function (qr) {
		            availableSumInsuredTypes.push(qr);
		        })
		    }
		    else {
		        availableQuoteResults.vehicles[0].availableSumInsuredTypes.forEach(function (qr) {
		            availableSumInsuredTypes.push(qr);
		        })
		    }
		}
		return availableSumInsuredTypes;
	}

	function isSumInsuredTypeAvailable(insuredType){
		var availableSumInsuredTypes = getAvailableSumInsuredTypes();
		return (availableSumInsuredTypes.indexOf(insuredType)>-1);
	}

	function isCoverTypeAvailable(coverTypeClass) {
		var availableCoverTypes = getAvailableCoverTypes() ;
		if (availableCoverTypes) {
			for (var key in availableCoverTypes) {
				var ct = availableCoverTypes[key] ;
				if (ct.superType == coverTypeClass )
					return true ;
			}
		}

		return false ;
	}

	function isCoverSubTypeAvailable(coverTypeClass, coverTypeSubClass) {
		var availableCoverTypes = getAvailableCoverTypes() ;
		var expectedType = coverTypeClasses[coverTypeClass].subClasses[coverTypeSubClass];
		return availableCoverTypes.indexOf(expectedType) !== -1 ;
	}

	function getRequoteOptions(pageName) {
		if ( ! pageName )
			pageName = defaultRequotePageName;

		return quoteRuleOptions[pageName] ;
	}

	function isReplacementAvailable(){
		//not used as this info is not available in vehicle page
		var availableQuoteResults = serviceResponseRepository.getLastResponseFrom('quickQuote') ;
		var sumInsuredTypes = [];
		if(availableQuoteResults && (availableQuoteResults.length>0)){
			sumInsuredTypes = availableQuoteResults[0].response.vehicles[0].availableSumInsuredTypes;

			console.log(sumInsuredTypes);
		}

		if(sumInsuredTypes.indexOf('replacement')>-1){
			return true;
		}else{
			return false;
		}

	}

	function getTestQuoteDeclineOptions(stepName) {
		return testQuoteDeclineOptions[stepName];
	}

	function getQuickQuoteOptionsForStep(stepName) {
		return quoteRuleOptions[stepName] ;
	}

	function getAllOfferings(){
		return quoteConfiguration.allOfferings;
	}

	function getOfferingPermutations(stepName, coverOptions) {
		var qqOptions = getQuickQuoteOptionsForStep(stepName);
		if ( ! qqOptions )
			return null;

		var offering = null
		if ( qqOptions.permutations.useSelectedOffering == true )
			offering = getSelectedOffering() ;

		return quoteConfiguration.getOfferingPermutations(qqOptions, coverOptions, getSelectedCoverType(), offering);
	}

	function getStateDefaultVoluntaryExcess(state, itemIndex){

		itemIndex = typeof itemIndex !== 'undefined' ? itemIndex : 0;
		
		if(window.globals.defaultExcessMapping == undefined || window.globals.defaultExcessMapping.options == undefined || state == undefined){
			return null;
		}

		var prefix = 'AU_';
		if(state.indexOf(prefix) == -1){
			state = prefix + state;
		}

		var excessMapping = window.globals.defaultExcessMapping.options[itemIndex];

		return excessMapping[state];
	}

	return {
		getQuickQuoteOptionsForStep: getQuickQuoteOptionsForStep,
		getRequoteOptions: getRequoteOptions,
		setSelectedCoverType: setSelectedCoverType,
		setDefaultCoverType: setDefaultCoverType,
		getSelectedCoverType: getSelectedCoverType,
		setSelectedPaymentFrequency: setSelectedPaymentFrequency,
		getSelectedPaymentFrequency: getSelectedPaymentFrequency,
		getSelectedPaymentFrequencyForService: getSelectedPaymentFrequencyForService,
		getSelectedQuoteResult: getSelectedQuoteResult,
		getSelectedQuoteResultForPayment: getSelectedQuoteResultForPayment,
		getSelectedOffering: getSelectedOffering,
		getOfferingPermutations: getOfferingPermutations,
		setSelectedOffering: setSelectedOffering,
		setAvailableQuoteResults: setAvailableQuoteResults,
		getMergedQuoteResults: getMergedQuoteResults,
		isCoverTypeAvailable: isCoverTypeAvailable,
		isCoverSubTypeAvailable: isCoverSubTypeAvailable,
		getTestQuoteDeclineOptions: getTestQuoteDeclineOptions,
		getAllCoverTypes: function() { return allCoverTypes },
		getAllPaymentFrequencies: function() {return allPaymentFrequencies},
		getAllQuoteTypes: function() {return allQuoteTypes},
		getCoverTypeSelector: getCoverTypeSelector,
		isReplacementAvailable: isReplacementAvailable,
		isSumInsuredTypeAvailable: isSumInsuredTypeAvailable,
		getAllOfferings:getAllOfferings,
		clearQuoteResults: clearQuoteResults,
		getStateDefaultVoluntaryExcess: getStateDefaultVoluntaryExcess
	}

}
